"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHomeArticles = exports.defaultHomeArticle1 = void 0;
var HomeArticleType_1 = require("@/pages/home/states/HomeArticleType");
exports.defaultHomeArticle1 = {
    title: 'The Many Ways a Real Estate Agent Can Help with your Home Purchase',
    caption: '10 December 2020 - Whether it’s your first home purchase or you’ve bought residences before, the procedures and regulations involved in home-buying can be truly daunting. A major acquisition like a new flat can affect your life in lots of ways for many years if not decades to come. That’s why it is so important to have a licensed and experienced professional estate agent by your side to help guide you from start to finish.',
    url: 'http://okay.com',
    image: 'https://images.okay.com/Contents/Source/0_637432170152509942.jpg',
    date: '15 DEC 2022',
    type: HomeArticleType_1.default.NEWS,
    alttext: ''
};
exports.defaultHomeArticles = [exports.defaultHomeArticle1, exports.defaultHomeArticle1, exports.defaultHomeArticle1, exports.defaultHomeArticle1, exports.defaultHomeArticle1, exports.defaultHomeArticle1];
